import { render } from "./RateCard.vue?vue&type=template&id=b8f44596"
import script from "./RateCard.vue?vue&type=script&lang=js"
export * from "./RateCard.vue?vue&type=script&lang=js"

import "./RateCard.vue?vue&type=style&index=0&id=b8f44596&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\matress-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__